import { render, staticRenderFns } from "./Black5Sale.vue?vue&type=template&id=1b22621e&scoped=true&"
import script from "./Black5Sale.vue?vue&type=script&lang=js&"
export * from "./Black5Sale.vue?vue&type=script&lang=js&"
import style0 from "./Black5Sale.vue?vue&type=style&index=0&id=1b22621e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b22621e",
  null
  
)

export default component.exports